import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoggingIn from 'src/Components/Pages/LoggingIn';
import LogOut from 'src/Components/LogOut';
import Dashboard from 'src/Components/Pages/Dashboard';
import Resources from 'src/Components/Pages/Resources';
import Four04 from 'src/Components/Pages/Four04';
import SupportDesk from 'src/Components/Pages/SupportDesk';
import Products from 'src/Components/Pages/Products';
import SparkingUpYourWorkshop from 'src/Components/Pages/SparkingUpYourWorkshop';
import SparkingUpYourCoaching from 'src/Components/Pages/SparkingUpYourCoaching';

const PageRoutes = () => (
    <BrowserRouter>
        <Routes>
            <Route path='/logout' element={<LogOut />} />
            <Route path='/login-lumina-practitioner/:practitionerId' element={<LoggingIn />} />
            <Route path='/' element={<Dashboard />} />
            <Route path='/resources' element={<Resources />} />
            <Route path='/support' element={<SupportDesk />} />
            <Route path='/products' element={<Products />} />
            <Route path='/spark-up-your-workshop' element={<SparkingUpYourWorkshop />} />
            <Route path='/spark-up-your-coaching' element={<SparkingUpYourCoaching />} />
            <Route path='*' element={<Four04 />} />
        </Routes>
    </BrowserRouter>
);

export default PageRoutes;